// extracted by mini-css-extract-plugin
export default {"main":"RealTime_main__5NcqL"};